import { render, staticRenderFns } from "./CategoryCollection.vue?vue&type=template&id=4e75ee3c&scoped=true&"
import script from "./CategoryCollection.vue?vue&type=script&lang=ts&"
export * from "./CategoryCollection.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryCollection.vue?vue&type=style&index=0&id=4e75ee3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e75ee3c",
  null
  
)

export default component.exports